import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";
import { scriptLoader } from "@metype/components";
import { btoa } from "isomorphic-base64";

class Metype extends Component {
  constructor(props) {
    super(props);
    this.onScriptLoad = this.onScriptLoad.bind(this);
  }

  componentDidMount() {
    this.onScriptLoad();
  }

  onScriptLoad() {
    if (window.talktype) {
      const metypeContainer = this.ref;
      // The rest of the commands are for metype to render the widget as an iframe
      metypeContainer.setAttribute("data-metype-window-height", window.innerHeight);
      metypeContainer.setAttribute("data-metype-screen-width", window.screen.width);
      switch (this.props.type) {
        case "reaction":
          window.talktype(() => window.talktype.pageReactionsIframe(this.ref));
          break;
        case "comment":
          window.talktype(() => window.talktype.commentWidgetIframe(this.ref));
          break;
        case "claps":
          window.talktype(() => window.talktype.clapsReactionIframe(this.ref));
          break;
      }
    } else {
      scriptLoader(get(this.props, ["metypeConfig", "host"], ""), this.onScriptLoad);
    }
  }

  render() {
    const metypeHost = get(this.props, ["metypeConfig", "host"], "");
    const metypeAccountId = get(this.props, ["metypeConfig", "accountId"], "");
    const metypePrimaryColor = get(this.props, ["metypeConfig", "primaryColor"], "");
    const metypeSecondaryColor = get(this.props, ["metypeConfig", "secondaryColor"], "");
    const metypeBgColor = get(this.props, ["metypeConfig", "bgColor"], "");
    const metypeFontColor = get(this.props, ["metypeConfig", "fontColor"], "");
    const metypeClassName = get(this.props, ["metypeConfig", "className"], "");
    if (!metypeHost) {
      return null;
    }

    return (
      <div
        className={metypeClassName}
        id={`metype-page-${this.props.type}-container-${btoa(this.props.pageURL)}`}
        ref={ref => (this.ref = ref)}
        data-metype-account-id={metypeAccountId}
        data-metype-host={metypeHost}
        data-metype-primary-color={metypePrimaryColor}
        data-metype-secondary-color={metypeSecondaryColor}
        data-metype-bg-color={metypeBgColor}
        data-metype-font-color={metypeFontColor}
        data-metype-page-url={this.props.pageURL}
      />
    );
  }
}

Metype.propTypes = {
  id: PropTypes.string,
  metypeConfig: PropTypes.shape({
    host: PropTypes.string,
    accountId: PropTypes.number,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    bgColor: PropTypes.string,
    fontColor: PropTypes.string,
    className: PropTypes.string
  }),
  type: PropTypes.string,
  pageURL: PropTypes.string
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(Metype);
